var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenLock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 20,
  viewBox: "0 0 15 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 8.5,
  width: 14,
  height: 11,
  rx: 1.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 4.5a.5.5 0 0 0 1 0zM4.5 8V4.5h-1V8zm3-6.5a3 3 0 0 1 3 3h1a4 4 0 0 0-4-4zm-3 3a3 3 0 0 1 3-3v-1a4 4 0 0 0-4 4z",
  fill: "currentColor"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 14.5,
  r: 2,
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenLock);
export { ForwardRef as ReactComponent };